<template>
  <b-container class="bv-example-row">
    <b-row>
      <b-col>
        <b-alert
          show
          variant="light"
          class="alert alert-custom alert-white alert-shadow fade show gutter-b"
        >
          <div class="alert-icon">
            <span class="svg-icon svg-icon-lg">
              <inline-svg src="media/svg/icons/Tools/Compass.svg" />
            </span>
          </div>
          <div class="alert-text d-flex justify-content-between align-items-center w-100">
            You are seeing a thermostat device
            <b-button variant="secondary" v-on:click="update" :disabled="btnUpdate==true">
              <b-spinner small v-show="btnUpdate == true"></b-spinner>
              Update firmware
            </b-button>
          </div>
        </b-alert>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <SuitchTemperatureWidget :device="current_device"/>
        <br>
        <SuitchLogWidget :device="current_device"/>

        
      </b-col>
      <b-col>
        <SuitchPropsWidget :device="current_device"/>
        <br>
        <SuitchStatusWidget :device="current_device"/>
        <br>
        <SuitchDetailsWidget :device="current_device"/>
        <br>
        <!-- <SuitchActionsWidget :device="current_device"/> -->
        <br >
        
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6"> </b-col>
      <b-col cols="4">
        <!-- more information here -->
      </b-col>
    </b-row>
  </b-container>

  <!--end::Example-->
</template>

<script>
import { FETCH_SINGLE_DEVICE,UPDATE_FIRMWARE } from "@/core/services/store/devices.module";
import SuitchStatusWidget from "@/view/content/widgets/suitch/suitch-status-widget.vue";
import SuitchPropsWidget from "@/view/content/widgets/suitch/suitch-props-widget.vue";
import SuitchLogWidget from "@/view/content/widgets/suitch/suitch-log-widget.vue";
// import SuitchActionsWidget from "@/view/content/widgets/suitch/suitch-actions-widget.vue";
import SuitchDetailsWidget from "@/view/content/widgets/suitch/suitch-details-widget.vue";
import SuitchTemperatureWidget from "@/view/content/widgets/suitch/suitch-nest-widget.vue";

export default {
  data() {
    return {
      global_wizard: {},
      current_device: null,
      btnUpdate: false,
    };
  },
  
  computed: {
  },

  components: {
    SuitchStatusWidget,
    SuitchPropsWidget,
    SuitchLogWidget,
    // SuitchActionsWidget,
    SuitchDetailsWidget,
    SuitchTemperatureWidget
  },

  methods: {
    update(e){
      e.preventDefault();
      this.btnUpdate = true;
      console.log("Trying to update:",this.$route.params.token);
      this.$store
            .dispatch(UPDATE_FIRMWARE, {
              token: this.$route.params.token,
            })
            .then(() => {
              console.log("firmware requested")
            })
            .catch(error => {
              console.error("Error firmware request:", error);
            })
            .finally(() => {
              this.btnUpdate = false;
            });
    }
  },
  mounted() {
    // console.log("route:",this.$route.params);
    const device_token = this.$route.params.token;

    this.$store
      .dispatch(FETCH_SINGLE_DEVICE, { device_token })
      // go to which page after successfully login
      .then((data) => {
        // download devices list
        this.current_device = data;
      });
    },
  };
</script>
